import Mass from "@FreeRider/Physics/Mass";
import Vehicle from '@FreeRider/Player/Vehicles/BaseVehicle';
import Camera from '@FreeRider/Camera';
import Screen from '@FreeRider/Screen';

class Wheel extends Mass
{
    public brake: boolean;
    public motor: number;
    public speed: number;

    /**
     * Constructor
     * @param parent
     */
    constructor(parent: Vehicle)
    {
        super(parent);
        this.motor = 0;
        this.brake = false;
        this.speed = 0;
    }

    /**
     * Moves the wheel a direction
     */
    public drive(x: number, y: number)
    {
        var pos = this.position;
        var vel = this.vel;
        var velX = vel.x;
        var velY = vel.y;

        var radius = this.radius;
        var factor = this.motor;

        var pX = x * factor;
        var pY = y * factor;

        pos.x += pX;
        pos.y += pY;

        if (this.brake)
        {
            var brakeFactor = -((x * velX) + (y * velY)) * 0.3;
            var brakeX = x * brakeFactor;
            var brakeY = y * brakeFactor;

            pos.x += brakeX;
            pos.y += brakeY;
        }

        this.speed = (x * velX + y * velY) / radius;
        this.angle += this.speed;
        this.contact = true;
    };

    /**
     * Draws the wheel to canvas
     * @param canvasCtx
     * @param camera
     * @param screen
     */
    public draw(canvasCtx: CanvasRenderingContext2D, camera: Camera, screen: Screen)
    {
        const zoom = camera.zoom;
        const radius = this.radius;
        const position = this.position;

        var draw_x = (this.position.x - camera.x) * zoom + (screen.width / 2);
        var draw_y = (this.position.y - camera.y) * zoom + (screen.height / 2);

        canvasCtx.beginPath();
        canvasCtx.fillStyle = 'rgba(0,0,0,0.5)';
        canvasCtx.arc(draw_x, draw_y, radius * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.closePath();
    }
}

export default Wheel;
